import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource, MatTable } from '@angular/material/table';

import { labelMaxLength, labelMinLength, urlMinLength } from '../../app.constants';
import { CoreApiService } from '../../core-api.service';
import { LoggingService } from '../../logging.service';
import { NotificationService } from '../../notification.service';
import { SiteBookmark } from '../../shared/models/site-settings.model';

@Component({
  selector: 'bookmark-manager-dialog',
  templateUrl: './bookmark-manager-dialog.component.html',
  styleUrls: ['./bookmark-manager-dialog.component.scss'],
  host: {
    class: 'mat-dialog-component',
    'test-id': 'bookmark-manager-dialog',
  },
})
export class BookmarkManagerDialogComponent implements OnInit {
  @ViewChild(MatTable) table: MatTable<SiteBookmark>;
  bookmarks: SiteBookmark[] = [{ label: '', url: '' }];
  dragDisabled = true;
  tableCols = ['position', 'label', 'url', 'delete'];
  tableDataSrc = new MatTableDataSource<SiteBookmark>();
  labelMaxLength = labelMaxLength;
  labelMinLength = labelMinLength;
  urlMinLength = urlMinLength;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { bookmarks: SiteBookmark[] } = { bookmarks: [] },
    private coreApi: CoreApiService,
    private logger: LoggingService,
    private notifications: NotificationService,
    public dialogRef: MatDialogRef<BookmarkManagerDialogComponent>
  ) {}

  ngOnInit(): void {
    if (this.data.bookmarks.length) {
      this.tableDataSrc.data = this.bookmarks = JSON.parse(JSON.stringify(this.data.bookmarks));
    } else {
      this.tableDataSrc.data = this.bookmarks;
    }
  }

  ngAfterViewChecked(): void {
    this.table.renderRows();
  }

  addBookmark(): void {
    this.bookmarks.push({ label: '', url: '' });
    this.tableDataSrc.data = this.bookmarks;
    this.table.renderRows();
  }

  removeBookmark(index: number): void {
    this.bookmarks.splice(index, 1);
    this.tableDataSrc.data = this.bookmarks;
    this.table.renderRows();
  }

  saveBookmarks(): void {
    this.coreApi.site.bookmarks.put(this.bookmarks).subscribe({
      next: () => {
        this.notifications.success('common.save.success');
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.logger.error(error);
        this.notifications.error('common.save.error');
      },
    });
  }

  drop(event: CdkDragDrop<SiteBookmark[]>): void {
    moveItemInArray(this.tableDataSrc.data, event.previousIndex, event.currentIndex);
    this.table.renderRows();
  }

  canSave(): boolean {
    return (
      this.bookmarks.every((bookmark) => bookmark.label && bookmark.url) &&
      this.bookmarks.every((bookmark) => bookmark.label.length <= labelMaxLength && bookmark.label.length >= labelMinLength) &&
      this.bookmarks.every((bookmark) => bookmark.url.length >= urlMinLength)
    );
  }
}
